import FieldInput from "./FieldInput"
import FieldFileInput from "./FieldFileInput"
import FieldSelect from "./FieldSelect";
import FieldTimeRange from "./FieldTimeRange";
import FieldTextEditor from "./FieldTextEditor";
import FieldRepeat from "./FieldRepeat";
import FieldDate from "./FieldDate";
import FieldDateTime from "./FieldDateTime";
import FieldAsyncSelect from "./FieldAsyncSelect";
import FieldUploadImage from "./FieldUploadImage";
import FieldCameraInput from "./FieldCameraInput";
import FieldInputPhoneNumber from "./FieldInputPhoneNumber";
import FieldSelectCity from "./FieldSelectCity";
import FieldTimeCoverInput from "./FieldTimeCover";
import FieldSearch from "./FieldSearch";

const Fields = {
    FieldInput,
    FieldSelect,
    FieldTimeRange,
    FieldFileInput,
    FieldTextEditor,
    FieldRepeat,
    FieldDate,
    FieldDateTime,
    FieldAsyncSelect,
    FieldUploadImage,
    FieldCameraInput,
    FieldInputPhoneNumber,
    FieldSelectCity,
    FieldTimeCoverInput,
    FieldSearch

}

export default Fields
